import { render } from "./STORY_POKER_CREATED.vue?vue&type=template&id=ec7b94fa&ts=true"
import script from "./STORY_POKER_CREATED.vue?vue&type=script&lang=ts"
export * from "./STORY_POKER_CREATED.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__